import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

import CreateRecordButton from "./CreateRecordButton";
import TkPopProduceEndBulkDialog from "../dialogTypes/TkPopProduceEndBulkDialog";

function TkPopProduceEndBulkButton(props) {

    const { id, createButtonName, onSuccess, onFailure, customizeErrorMsgCallback, onTrigger, ...others } = props;

    const { t } = useTranslation();

    const [open, setOpen] = useState(false);

    const [schema, setSchema] = useState();

    useEffect( () => {

        let schema = {

            name: "TkPopProductManage",
            type: "BASE TABLE",
            searchAll: false,

            columns: [

                {

                    name: "planId",
                    type: "BIGINT(20)",
                    nullable: "NO",
                    default: null,
                    required: true,
                    hideInForm: true,
                    formOrder: 0,
                    formItemType: "text",

                },
                
            ]

        };

        setSchema(schema);

    }, []);

    const onOpen = () => {

        setOpen(true);
        onTrigger(true)
    };

    const onClose = () => {

        setOpen(false);
        onTrigger(false)
    };

    const onCreateSuccess = (msg) => {

        if (onSuccess) {

            onSuccess(msg);

        }

    };

    const modifyUrlCallback = (url, id) => {

        if ( id === "ElectrodeProcessing" ) {

            return `${url}?${id}`;

        }

        return url;

    }

    return (
        <>
            <CreateRecordButton createButtonName={createButtonName} id={id + "-create-produceEnd-button"} onClick={onOpen} {...others} />
            <TkPopProduceEndBulkDialog
                id={id+"create-dialog"}
                mode="create"
                formId={id+"create-form"}
                title={ t ( "dialog.title.Produce.end" ) }
                schema={schema}
                initialData={undefined}
                open={open}
                onClose={onClose}
                onSuccess={onCreateSuccess}
                customizeErrorMsgCallback={customizeErrorMsgCallback}
                modifyUrlCallback={(url) => modifyUrlCallback(url, id)}
                menuId={id}
            />
        </>
    )
}

export default TkPopProduceEndBulkButton;